import { render } from "./AutocallButtonCert.vue?vue&type=template&id=1327a2fb&scoped=true&ts=true"
import script from "./AutocallButtonCert.vue?vue&type=script&lang=ts"
export * from "./AutocallButtonCert.vue?vue&type=script&lang=ts"

import "./AutocallButtonCert.vue?vue&type=style&index=0&id=1327a2fb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1327a2fb"]])

export default __exports__